import { get } from 'lodash';
import { CLOSE_COMPLIANCE_SEASON_ENDPOINT } from '../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../redux/epics/utils';

const CLOSE_COMPLIANCE_SEASON = createAPILifecycleActionTypes('CLOSE_COMPLIANCE_SEASON');

export const closeComplianceSeasonActions = createAPILifecycleActions(CLOSE_COMPLIANCE_SEASON.NAME);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CLOSE_COMPLIANCE_SEASON.BEGIN:
      return { ...state, isFetching: true, error: null };
    case CLOSE_COMPLIANCE_SEASON.SUCCESS:
      return { ...state, isFetching: false, data: payload, error: null };
    case CLOSE_COMPLIANCE_SEASON.FAILURE:
      return { ...state, isFetching: false, error: payload || 'Close request failed' };
    case CLOSE_COMPLIANCE_SEASON.CLEAR:
      return initialState;
    default:
      return state;
  }
};

// clientId/country/studyPeriod/accessToken injected by the shared epic context.
// Caller supplies { body: { confirmClose: true } }.
// Success payload = { closeId, status: 'PENDING_APPROVAL', closedBy, closedAt }.
// Amplify rejects the promise on any non-2xx status (e.g. the 400 the service
// returns for "already closed" / invalid input), so the real statusMessage
// lives on the rejected error's response body, not a thrown JS message.
export const closeComplianceSeasonEpic = createAmplifyAPICallEpic({
  actionType: CLOSE_COMPLIANCE_SEASON.BEGIN,
  api: CLOSE_COMPLIANCE_SEASON_ENDPOINT,
  successCallback: response => [closeComplianceSeasonActions.SUCCESS(response.body)],
  errorCallback: error => [
    closeComplianceSeasonActions.FAILURE(
      get(error, 'response.data.statusMessage') ||
        get(error, 'response.data.message') ||
        get(error, 'message') ||
        'Close request failed',
    ),
  ],
});
